import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "file-upload-form" }

import { useI18n } from "vue-i18n";

import { svgIcon, baseFile } from "@/common/components";

import { FileType } from "@/common/types/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'file-upload',
  props: {
    model: { type: Boolean, default: false },
    extensions: {},
    background: { default: "#eeeeee" }
  },
  emits: ["update-data", "model-download"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

function update(data: FileType) {
  emit("update-data", data);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseFile), {
      extensions: props.extensions,
      onChange: update
    }, null, 8, ["extensions"]),
    (__props.model)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "model-download",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('model-download')))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "download",
            size: "1.5rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.texts.model_download")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})